// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
exports.push([module.id, ".dzone[data-v-3269b7cf]{outline:none}.dzone-container[data-v-3269b7cf]{border:1px dashed #bdbdbd;border-radius:8px}div.input-container[data-v-3269b7cf]{min-width:50%}.v-input[data-v-3269b7cf]  div.v-input__control div.v-input__slot{margin-top:4px;margin-bottom:0!important}input.file-btn[data-v-3269b7cf]{display:none}", ""]);
// Exports
module.exports = exports;
